import tt, { Component as bt, useContext as wt, useRef as kt, useMemo as _t, useCallback as Ct } from "react";
import { P as G } from "./index-BpaEWJM0.mjs";
import { r as xt } from "./jsx-runtime-3tyXYecC.mjs";
import { unstable_batchedUpdates as it } from "react-dom";
const Tt = (e, t) => Object.assign({}, e, t), q = {
  batchUpdates: "useSyncExternalStore" in tt,
  devtools: !1,
  middlewares: /* @__PURE__ */ new Set(),
  mutator: Tt
}, at = /* @__PURE__ */ new WeakMap(), At = function(t, n, o, r, i) {
  r === void 0 && (r = () => {
  }), i === void 0 && (i = {});
  const u = function f(d, g) {
    return g === void 0 && (g = `${o}.dispatch`), d({
      setState: t.mutator,
      getState: t.getState,
      get actions() {
        return at.has(n) || at.set(n, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. Please check action '${g}' of Store '${t.key}' and use 'dispatch' instead`)), i;
      },
      dispatch: f
    }, r());
  };
  return function() {
    return u(n(...arguments), o);
  };
}, B = function(t, n, o, r) {
  return o === void 0 && (o = () => ({})), r === void 0 && (r = null), Object.keys(t).reduce((i, u) => (i[u] = At(n, t[u], u, o, r || i), i), {});
};
function Et(e) {
  for (var t = e.length, n = t ^ t, o = 0, r; t >= 4; )
    r = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, r = (r & 65535) * 1540483477 + (((r >>> 16) * 1540483477 & 65535) << 16), r ^= r >>> 24, r = (r & 65535) * 1540483477 + (((r >>> 16) * 1540483477 & 65535) << 16), n = (n & 65535) * 1540483477 + (((n >>> 16) * 1540483477 & 65535) << 16) ^ r, t -= 4, ++o;
  switch (t) {
    case 3:
      n ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      n ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      n ^= e.charCodeAt(o) & 255, n = (n & 65535) * 1540483477 + (((n >>> 16) * 1540483477 & 65535) << 16);
  }
  return n ^= n >>> 13, n = (n & 65535) * 1540483477 + (((n >>> 16) * 1540483477 & 65535) << 16), n ^= n >>> 15, (n >>> 0).toString(36);
}
function Pt(e, t, n) {
  const o = n ? "" : Object.keys(t).reduce((r, i) => r + t[i].toString(), "");
  return [n, Et(o + JSON.stringify(e))].filter(Boolean).join("__");
}
function ie(e) {
  let {
    name: t = "",
    initialState: n,
    actions: o
  } = e, r;
  return {
    get key() {
      return r || (r = Pt(n, o, t));
    },
    initialState: n,
    actions: o
  };
}
const Rt = Object.prototype.hasOwnProperty, x = /* @__PURE__ */ new WeakMap();
function $(e, t) {
  if (e === t)
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  } else {
    const n = "" + e, o = "" + t;
    if (n !== o || n[0] === "[" && n !== "[object Object]")
      return !1;
    let r;
    x.has(e) ? r = x.get(e) : (r = Object.keys(e), x.set(e, r));
    let i;
    if (x.has(t) ? i = x.get(t) : (i = Object.keys(t), x.set(t, i)), r.length !== i.length)
      return !1;
    for (let u = 0; u < r.length; u++)
      if (!Rt.call(t, r[u]) || e[r[u]] !== t[r[u]])
        return !1;
    return !0;
  }
}
const Ot = (e) => (t) => (n) => {
  let o;
  const r = e.getState(), i = t(r, n, (u) => {
    o = u;
  });
  return $(i, r) || e.setState(i), o;
}, Mt = (e, t) => Array.from(t).concat(Ot).reduceRight((n, o) => o(e)(n), q.mutator), Ft = (e) => function() {
  return e(...arguments);
};
var dt = { exports: {} }, ht = {};
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  var t, n, o, r;
  if (typeof performance == "object" && typeof performance.now == "function") {
    var i = performance;
    e.unstable_now = function() {
      return i.now();
    };
  } else {
    var u = Date, f = u.now();
    e.unstable_now = function() {
      return u.now() - f;
    };
  }
  if (typeof window > "u" || typeof MessageChannel != "function") {
    var d = null, g = null, v = function() {
      if (d !== null) try {
        var s = e.unstable_now();
        d(!0, s), d = null;
      } catch (a) {
        throw setTimeout(v, 0), a;
      }
    };
    t = function(s) {
      d !== null ? setTimeout(t, 0, s) : (d = s, setTimeout(v, 0));
    }, n = function(s, a) {
      g = setTimeout(s, a);
    }, o = function() {
      clearTimeout(g);
    }, e.unstable_shouldYield = function() {
      return !1;
    }, r = e.unstable_forceFrameRate = function() {
    };
  } else {
    var R = window.setTimeout, nt = window.clearTimeout;
    if (typeof console < "u") {
      var W = window.cancelAnimationFrame;
      typeof window.requestAnimationFrame != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), typeof W != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var O = !1, M = null, I = -1, rt = 5, ot = 0;
    e.unstable_shouldYield = function() {
      return e.unstable_now() >= ot;
    }, r = function() {
    }, e.unstable_forceFrameRate = function(s) {
      0 > s || 125 < s ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : rt = 0 < s ? Math.floor(1e3 / s) : 5;
    };
    var st = new MessageChannel(), D = st.port2;
    st.port1.onmessage = function() {
      if (M !== null) {
        var s = e.unstable_now();
        ot = s + rt;
        try {
          M(!0, s) ? D.postMessage(null) : (O = !1, M = null);
        } catch (a) {
          throw D.postMessage(null), a;
        }
      } else O = !1;
    }, t = function(s) {
      M = s, O || (O = !0, D.postMessage(null));
    }, n = function(s, a) {
      I = R(function() {
        s(e.unstable_now());
      }, a);
    }, o = function() {
      nt(I), I = -1;
    };
  }
  function K(s, a) {
    var c = s.length;
    s.push(a);
    t: for (; ; ) {
      var l = c - 1 >>> 1, h = s[l];
      if (h !== void 0 && 0 < L(h, a)) s[l] = a, s[c] = h, c = l;
      else break t;
    }
  }
  function S(s) {
    return s = s[0], s === void 0 ? null : s;
  }
  function F(s) {
    var a = s[0];
    if (a !== void 0) {
      var c = s.pop();
      if (c !== a) {
        s[0] = c;
        t: for (var l = 0, h = s.length; l < h; ) {
          var k = 2 * (l + 1) - 1, _ = s[k], E = k + 1, C = s[E];
          if (_ !== void 0 && 0 > L(_, c)) C !== void 0 && 0 > L(C, _) ? (s[l] = C, s[E] = c, l = E) : (s[l] = _, s[k] = c, l = k);
          else if (C !== void 0 && 0 > L(C, c)) s[l] = C, s[E] = c, l = E;
          else break t;
        }
      }
      return a;
    }
    return null;
  }
  function L(s, a) {
    var c = s.sortIndex - a.sortIndex;
    return c !== 0 ? c : s.id - a.id;
  }
  var m = [], b = [], mt = 1, y = null, p = 3, U = !1, w = !1, A = !1;
  function N(s) {
    for (var a = S(b); a !== null; ) {
      if (a.callback === null) F(b);
      else if (a.startTime <= s) F(b), a.sortIndex = a.expirationTime, K(m, a);
      else break;
      a = S(b);
    }
  }
  function Y(s) {
    if (A = !1, N(s), !w) if (S(m) !== null) w = !0, t(z);
    else {
      var a = S(b);
      a !== null && n(Y, a.startTime - s);
    }
  }
  function z(s, a) {
    w = !1, A && (A = !1, o()), U = !0;
    var c = p;
    try {
      for (N(a), y = S(m); y !== null && (!(y.expirationTime > a) || s && !e.unstable_shouldYield()); ) {
        var l = y.callback;
        if (typeof l == "function") {
          y.callback = null, p = y.priorityLevel;
          var h = l(y.expirationTime <= a);
          a = e.unstable_now(), typeof h == "function" ? y.callback = h : y === S(m) && F(m), N(a);
        } else F(m);
        y = S(m);
      }
      if (y !== null) var k = !0;
      else {
        var _ = S(b);
        _ !== null && n(Y, _.startTime - a), k = !1;
      }
      return k;
    } finally {
      y = null, p = c, U = !1;
    }
  }
  var vt = r;
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(s) {
    s.callback = null;
  }, e.unstable_continueExecution = function() {
    w || U || (w = !0, t(z));
  }, e.unstable_getCurrentPriorityLevel = function() {
    return p;
  }, e.unstable_getFirstCallbackNode = function() {
    return S(m);
  }, e.unstable_next = function(s) {
    switch (p) {
      case 1:
      case 2:
      case 3:
        var a = 3;
        break;
      default:
        a = p;
    }
    var c = p;
    p = a;
    try {
      return s();
    } finally {
      p = c;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = vt, e.unstable_runWithPriority = function(s, a) {
    switch (s) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        s = 3;
    }
    var c = p;
    p = s;
    try {
      return a();
    } finally {
      p = c;
    }
  }, e.unstable_scheduleCallback = function(s, a, c) {
    var l = e.unstable_now();
    switch (typeof c == "object" && c !== null ? (c = c.delay, c = typeof c == "number" && 0 < c ? l + c : l) : c = l, s) {
      case 1:
        var h = -1;
        break;
      case 2:
        h = 250;
        break;
      case 5:
        h = 1073741823;
        break;
      case 4:
        h = 1e4;
        break;
      default:
        h = 5e3;
    }
    return h = c + h, s = { id: mt++, callback: a, priorityLevel: s, startTime: c, expirationTime: h, sortIndex: -1 }, c > l ? (s.sortIndex = c, K(b, s), S(m) === null && s === S(b) && (A ? o() : A = !0, n(Y, c - l))) : (s.sortIndex = h, K(m, s), w || U || (w = !0, t(z))), s;
  }, e.unstable_wrapCallback = function(s) {
    var a = p;
    return function() {
      var c = p;
      p = a;
      try {
        return s.apply(this, arguments);
      } finally {
        p = c;
      }
    };
  };
})(ht);
dt.exports = ht;
var ut = dt.exports;
const pt = {
  scheduling() {
    return typeof window < "u" && typeof MessageChannel == "function";
  }
};
let J = !1;
function ct(e) {
  return !q.batchUpdates || !pt.scheduling() || J ? it(e) : (J = !0, ut.unstable_scheduleCallback(ut.unstable_ImmediatePriority, function() {
    it(e), J = !1;
  }));
}
const Q = [];
let V;
function Lt(e) {
  if (!q.batchUpdates || !pt.scheduling()) return ct(() => e());
  Q.includes(e) || Q.push(e), !V && (V = ct(() => {
    let t;
    for (; t = Q.shift(); ) t();
    V = null;
  }));
}
function Ut(e, t) {
  let n = [], o = t;
  const r = {
    key: e,
    getState() {
      return o;
    },
    setState(i) {
      o = i, Lt(r.notify);
    },
    resetState() {
      r.setState(t);
    },
    notify() {
      for (let i = 0; i < n.length; i++)
        n[i](r.getState());
    },
    subscribe(i) {
      return n = n.concat(i), function() {
        n = n.filter((f) => f !== i);
      };
    },
    listeners() {
      return n;
    }
  };
  return r.mutator = Mt(r, q.middlewares), r;
}
const Ht = Ft(Ut), qt = "__global__";
class gt {
  constructor(t) {
    var n = this;
    t === void 0 && (t = qt), this.stores = /* @__PURE__ */ new Map(), this.initStore = (o, r) => {
      const {
        initialState: i,
        actions: u
      } = r, f = Ht(o, i), d = B(u, f), g = {
        storeState: f,
        actions: d
      };
      return this.stores.set(o, g), g;
    }, this.getStore = function(o, r) {
      r === void 0 && (r = n.defaultScope);
      const i = n.generateKey(o, r);
      return n.stores.get(i) || n.initStore(i, o);
    }, this.deleteStore = function(o, r) {
      r === void 0 && (r = n.defaultScope);
      const i = n.generateKey(o, r);
      n.stores.delete(i);
    }, this.generateKey = (o, r) => `${o.key}@${r}`, this.defaultScope = t;
  }
}
const H = new gt(), et = /* @__PURE__ */ tt.createContext({
  globalRegistry: H,
  getStore: H.getStore
}, () => 0), $t = ["children", "scope", "isGlobal"];
function Wt(e, t) {
  if (e == null) return {};
  var n = {}, o = Object.keys(e), r, i;
  for (i = 0; i < o.length; i++)
    r = o[i], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
const X = () => () => {
};
class P extends bt {
  static getDerivedStateFromProps(t, n) {
    const {
      scope: o
    } = t, r = o !== n.scope;
    let i = null;
    if (r) {
      const u = n.bindContainerActions(o);
      i = {
        scope: o,
        scopedActions: u
      };
    }
    return n.triggerContainerAction(t), i;
  }
  constructor(t, n) {
    super(t, n), this.registry = new gt("__local__"), this.scopedHooks = {}, this.bindContainerActions = (i) => {
      const {
        storeType: u,
        hooks: f
      } = this.constructor, {
        api: d
      } = this.state, {
        storeState: g
      } = d.getStore(u, i), v = B(u.actions, g, this.getContainerProps);
      return this.scopedHooks = B(f, g, this.getContainerProps, v), this.actionProps = null, v;
    }, this.triggerContainerAction = (i) => {
      const u = this.filterActionProps(i), f = this.actionProps;
      $(f, u) || (this.actionProps = u, this.scopedHooks.onInit ? (this.scopedHooks.onInit(), this.scopedHooks.onInit = null) : this.scopedHooks.onUpdate());
    }, this.filterActionProps = (i) => Wt(i, $t), this.getContainerProps = () => this.actionProps;
    const {
      // These fallbacks are needed only to make enzyme shallow work
      // as it does not fully support provider-less Context enzyme#1553
      globalRegistry: o = H,
      getStore: r = H.getStore
    } = this.context;
    this.state = {
      api: {
        globalRegistry: o,
        getStore: (i, u) => this.getScopedStore(i, u) || r(i)
      },
      // stored to make them available in getDerivedStateFromProps
      // as js context there is null https://github.com/facebook/react/issues/12612
      bindContainerActions: this.bindContainerActions,
      triggerContainerAction: this.triggerContainerAction,
      scope: t.scope
    }, this.state.scopedActions = this.bindContainerActions(t.scope);
  }
  componentDidUpdate(t) {
    this.props.scope !== t.scope && (this.triggerScopeChange(t.scope), this.deleteScopedStore(t.scope));
  }
  componentWillUnmount() {
    Promise.resolve().then(() => {
      this.scopedHooks.onCleanup(), this.deleteScopedStore();
    });
  }
  getRegistry() {
    return !this.props.scope && !this.props.isGlobal ? this.registry : this.state.api.globalRegistry;
  }
  getScopedStore(t, n) {
    n === void 0 && (n = this.props.scope);
    const {
      storeType: o
    } = this.constructor;
    if (t !== o)
      return null;
    const {
      storeState: r
    } = this.getRegistry().getStore(t, n);
    return {
      storeState: r,
      actions: this.state.scopedActions
    };
  }
  triggerScopeChange(t) {
    const {
      storeType: n
    } = this.constructor;
    this.getScopedStore(n, t).storeState.notify();
  }
  deleteScopedStore(t) {
    t === void 0 && (t = this.props.scope);
    const {
      storeType: n
    } = this.constructor, {
      storeState: o
    } = this.getScopedStore(n, t);
    t != null && !o.listeners().length && this.getRegistry().deleteStore(n, t);
  }
  render() {
    const {
      children: t
    } = this.props;
    return /* @__PURE__ */ tt.createElement(et.Provider, {
      value: this.state.api
    }, t);
  }
}
P.propTypes = {
  children: G.node,
  scope: G.string,
  isGlobal: G.bool
};
P.storeType = null;
P.hooks = null;
P.contextType = et;
function ae(e, t) {
  var n;
  let {
    onInit: o = X,
    onUpdate: r = X,
    onCleanup: i = X,
    displayName: u = ""
  } = t === void 0 ? {} : t;
  return n = class extends P {
  }, n.storeType = e, n.displayName = u || `Container(${e.key.split("__")[0]})`, n.hooks = {
    onInit: o,
    onUpdate: r,
    onCleanup: i
  }, n;
}
var yt = { exports: {} }, St = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T = xt;
function It(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Dt = typeof Object.is == "function" ? Object.is : It, Kt = T.useState, Nt = T.useEffect, Yt = T.useLayoutEffect, zt = T.useDebugValue;
function Gt(e, t) {
  var n = t(), o = Kt({ inst: { value: n, getSnapshot: t } }), r = o[0].inst, i = o[1];
  return Yt(function() {
    r.value = n, r.getSnapshot = t, Z(r) && i({ inst: r });
  }, [e, n, t]), Nt(function() {
    return Z(r) && i({ inst: r }), e(function() {
      Z(r) && i({ inst: r });
    });
  }, [e]), zt(n), n;
}
function Z(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Dt(e, n);
  } catch {
    return !0;
  }
}
function Jt(e, t) {
  return t();
}
var Qt = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Jt : Gt;
St.useSyncExternalStore = T.useSyncExternalStore !== void 0 ? T.useSyncExternalStore : Qt;
yt.exports = St;
var Vt = yt.exports;
function Xt(e, t) {
  return e === t;
}
function Zt(e, t, n) {
  if (t === null || n === null || t.length !== n.length) return !1;
  if (e && t.length === 2)
    return t[0] === n[0] && $(t[1], n[1]);
  for (let o = 0; o < t.length; o++)
    if (!Xt(t[o], n[o])) return !1;
  return !0;
}
function lt(e, t) {
  t === void 0 && (t = !1);
  let n = [], o, r = !1;
  return function() {
    if (r && Zt(t, arguments, n))
      return o;
    const f = e.apply(this, arguments);
    return !t && $(f, o) || (o = f, r = !0, n = arguments), o;
  };
}
function jt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  const o = t.pop(), r = Array.isArray(t[0]) ? t[0] : t, i = lt(function() {
    return o.apply(null, arguments);
  }), u = lt(function() {
    const f = [];
    for (let d = 0; d < r.length; d++)
      f.push(r[d].apply(null, arguments));
    return i.apply(null, f);
  }, !0);
  return u.resultFunc = o, u.dependencies = r, u;
}
function ft(e) {
  const t = typeof e.resultFunc == "function" && Array.isArray(e.dependencies), n = t ? e.dependencies : [(r) => r, (r, i) => i], o = t ? e.resultFunc : e;
  return jt(n, o);
}
const j = /* @__PURE__ */ new WeakMap();
function Bt(e, t, n) {
  if (!n) {
    j.has(t) || j.set(t, /* @__PURE__ */ new WeakMap());
    const o = j.get(t);
    return o.has(e) || o.set(e, ft(e)), o.get(e);
  }
  return ft(e);
}
const te = () => {
}, ee = (e) => e;
function ue(e, t) {
  let {
    selector: n
  } = {};
  return function(r) {
    const {
      getStore: i
    } = wt(et), {
      storeState: u,
      actions: f
    } = i(e), d = r !== void 0, g = kt(r);
    g.current = r;
    const v = _t(() => n ? Bt(n, u, d) : n === null ? te : ee, [d, u]), R = Ct(() => {
      const W = i(e).storeState.getState();
      return v(W, g.current);
    }, [i, v]);
    return [Vt.useSyncExternalStore(u.subscribe, R, R), f];
  };
}
export {
  ue as a,
  ie as b,
  ae as c
};
//# sourceMappingURL=hook-CrqgbaQ-.mjs.map
